export { AppointmentModel, AppointmentLocation, parseAppointmentModel } from "./models";
